export default {
  container: {
    cursor: 'pointer',
    fontSize: '30px',
    height: '1em',
    width: '1.8em',
    display: 'flex',
    '& input': {
      opacity: '0',
      height: '0',
      width: '0',
      '&:checked + *': {
        background: '#b3cb45',
        borderColor: '#a0be17',
        '&:after': {
          borderColor: '#a0be17',
          transform: 'translateX(.8em)'
        }
      }
    }
  },
  disabled: {
    '& $slider': {
      '&:after': {
        background: '#ececec'
      }
    }
  },
  slider: {
    background: '#ececec',
    border: '1px solid #9B9B9B',
    borderRadius: '1em',
    padding: '0.11em',
    width: '100%',
    height: '100%',
    position: 'relative',
    '&:after': {
      content: '""',
      width: '0.67em',
      height: '0.67em',
      borderRadius: '100%',
      background: '#fff',
      border: '1px solid #9B9B9B',
      position: 'absolute',
      transition: 'transform .1s cubic-bezier(0.39, 0.58, 0.57, 1)'
    }
  }
}
